// --------------------------------------------------------
// ALL APPOINTMENTS - CollaboratorInitialAllAppointments
// --------------------------------------------------------

// --------------------------------------------------------
// GENERAL
// --------------------------------------------------------
import React, { useEffect, useCallback, useState } from 'react'
import SchedulingCard from '../../models/core/scheduling/SchedulingCard';
import { H2, Text } from '../UI/generalLayout/Layout.styled'
import { SchedulingService } from '../../core/http/service/SchedulingService';
import BaseResponse from '../../models/core/BaseResponse';
import { TypeCards } from '../../enums/TypeCards';
import CardResult from '../cardResult/CardResult';
import { CircularProgress, InputAdornment, OutlinedInput } from '@mui/material';
import moment from 'moment';
import styled from 'styled-components';
import useResponsiveInfo from '../../hooks/useResponsiveInfo';
import { Search } from '@mui/icons-material';

// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
// --------------------------------------------------------

// --------------------------------------------------------
// ALL APPOINTMENTS INTERFACE
// --------------------------------------------------------

interface ICollaboratorInitialAllAppointments {
    onSelectCard: any;
}
/**
/**
 * A component that renders a Component description here.
 *
 * @param props The component props.
 * @returns The component JSX.
 */
//<div style={{ backgroundColor: 'red', height: 500, overflowY: 'scroll'}}>
export const AllAppointmentsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(285px, 1fr));
  gap: 16px;
  width: 100%;
  margin-top: 16px;
  padding-bottom: 24px;
  box-sizing: border-box;

  & > div {
    width: 100% !important;
    max-width: 100% !important;
    margin-right: 0 !important;
  }
`;

const CollaboratorInitialAllAppointments = ({ onSelectCard }: ICollaboratorInitialAllAppointments) => {
    // --------------------------------------------------------
    // ALL APPOINTMENTS PRIVATE DECLARATIONS
    // --------------------------------------------------------
    const [allAppointments, setAllAppointments] = useState<any[]>([])
    const [isLoading, setIsLoading] = useState(false)
    const [nomeProfissionalSearchQuery, setSearchQuery] = useState<string>('')
    const { isMobile } = useResponsiveInfo();

    const fetchAllAppointments = useCallback(async (searchQuery: string) => {
        setIsLoading(true)
        const today = moment.utc();
        const lastYear = moment.utc().subtract(1, 'years')
        const service: SchedulingService<any> = new SchedulingService();
        const response: any = await service.getAllAppointments(lastYear.format('YYYY-MM-DD'));

        const scheduling: BaseResponse<any> = new BaseResponse().fromJSON(
            response.data
        );

        const schedulingCard: SchedulingCard[] = [];
        
        scheduling?.data?.forEach((data: any) => {
            schedulingCard.push(new SchedulingCard().fromJSON(data));
        });
    

        const todosHorarios: any[] = []
        const anteriores = schedulingCard.filter((r: any) => { return moment(r.horario, 'YYYY-MM-DDTHH:mm').isBefore(today) })
        const posteriores = schedulingCard.filter((r: any) => { return moment(r.horario, 'YYYY-MM-DDTHH:mm').isAfter(today) })

        posteriores.forEach((h: any) => {
            todosHorarios.push(h)
        })
        anteriores.forEach(h => {
            todosHorarios.push(h)
        })

        setAllAppointments(todosHorarios.filter(h => { 
            return h.profissionalNome.toUpperCase().includes(searchQuery.toUpperCase())}))
        setIsLoading(false)

    }, [])

    useEffect(() => {
        if(nomeProfissionalSearchQuery === '' || nomeProfissionalSearchQuery.length >= 3){
            fetchAllAppointments(nomeProfissionalSearchQuery);
        }
    }, [nomeProfissionalSearchQuery])

    return (
        <div style={{ width: '100%', marginTop: '8px' }}>
            {/* Título à esquerda e busca à direita alinhados com space-between */}
            <div style={{ 
                display: 'flex', 
                flexDirection: isMobile ? 'column' : 'row', 
                justifyContent: 'space-between',
                alignItems: isMobile ? 'flex-start' : 'center',
                gap: '16px', 
                marginBottom: '24px',
                width: '100%'
            }}>
                <H2 style={{ color: '#0F172A', fontWeight: 700, fontSize: '18px', display: 'flex', alignItems: 'center', gap: '8px', margin: 0, flexShrink: 0 }}>
                    <span style={{ width: 4, height: 18, background: '#0A5190', borderRadius: 2, display: 'inline-block' }}></span>
                    <span>Consultas agendadas</span>
                    <span style={{ background: '#F0F9FF', color: '#0A5190', padding: '2px 8px', borderRadius: '12px', fontSize: '12px', fontWeight: 600 }}>
                        {allAppointments.length}
                    </span>
                </H2>

                <OutlinedInput
                    sx={{ 
                        borderRadius: "8px", 
                        width: isMobile ? "100%" : "300px",
                        height: "38px",
                        background: "#FFFFFF",
                        fontSize: "13.5px",
                        margin: 0,
                        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.02)",
                        "& .MuiOutlinedInput-input": {
                            padding: "8px 12px",
                            height: "100%",
                            boxSizing: "border-box"
                        }
                    }}
                    id="outlined-adornment-amount"
                    startAdornment={
                        <InputAdornment position="start" style={{ marginRight: "4px" }}>
                            <Search style={{ color: "#64748B", fontSize: "19px" }} />
                        </InputAdornment>
                    }
                    placeholder="Buscar por profissional..."
                    value={nomeProfissionalSearchQuery}
                    onChange={(event: any) => {
                        setSearchQuery(event.target.value)
                    }}
                />
            </div>

            {isLoading ? (
                <div style={{ textAlign: 'center', padding: '50px 0', color: '#64748B' }}>
                    <CircularProgress size={30} style={{ color: '#0A5190' }} />
                    <p style={{ marginTop: '12px', fontSize: '13.5px' }}>Carregando consultas...</p>
                </div>
            ) : allAppointments && allAppointments.length > 0 ? (
                <AllAppointmentsContainer>
                    {allAppointments.map((dados, index) => (
                        <CardResult
                            key={dados.id || index}
                            id={dados.id}
                            render={TypeCards.CardConsulta}
                            horario={dados.horario}
                            foto={dados.profissionalFoto}
                            nomeMedico={dados.profissionalNome}
                            titulo={dados.profissionalEspecialidade}
                            unidade={dados.unidadeAtendimentoNome}
                            onClick={onSelectCard}
                        />
                    ))}
                </AllAppointmentsContainer>
            ) : (
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "40px 24px",
                    background: "#F8FAFC",
                    border: "1px dashed #CBD5E1",
                    borderRadius: "12px",
                    width: "100%",
                    color: "#64748B",
                    textAlign: "center",
                    margin: "16px 0"
                }}>
                    <Search style={{ fontSize: 28, color: "#94A3B8", marginBottom: "8px" }} />
                    <span style={{ fontWeight: 600, fontSize: "14.5px", color: "#0F172A" }}>Nenhuma consulta encontrada</span>
                    <span style={{ fontSize: "13px", marginTop: "2px" }}>Tente pesquisar com outro nome de profissional.</span>
                </div>
            )}
        </div>
    )
}

export default CollaboratorInitialAllAppointments